import { Wrapper } from './Container.styled';

export const Container = ({ children }) => {
 return <Wrapper>{children}</Wrapper>;
};
